import axios from 'axios'

// getting the token from the backend, base on Client Credentials Grant type
// Client secret comes from passport database table oauth_clients
let data = {
  grant_type: 'client_credentials',
  client_id: 3,
  client_secret: 'zIYBpQV70aAs7Lj6kzt6iejyZmIDCJZsxCMQsdmK', // Secret on oauth_clients table
  username: 'frontend',
  scope: ''
}

// Set url of backend
// axios.defaults.baseURL = 'https://admin.emcasa.eu'
axios.defaults.baseURL = 'https://admin.atlantico.casa'
// axios.defaults.baseURL = 'http://localhost'

var getToken = new Promise(function (resolve, reject) {
  axios.post('/oauth/token', data).then(response => {
    var token = response.data.access_token
    setAuthHeader(token)
    localStorage.setItem('backendToken', token)
    resolve(response)
  }).catch(response => {
    reject(response)
  })
})

function setAuthHeader (store) {
  axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + store
  }
}

export { getToken, setAuthHeader }
